"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectModal = void 0;
const lucide_1 = require("lucide");
const event_1 = require("@/common/event");
const form_1 = require("@/ui/form/form");
const i18n_1 = require("@/common/i18n");
const modal_1 = require("./modal");
class ObjectModal extends modal_1.Modal {
    constructor(target) {
        super(target, { id: "object-settings", title: "", icon: lucide_1.SlidersHorizontal });
        // events
        this._onSave = new event_1.Emitter();
        this._data = null;
        this._addFooterButton("save", { text: (0, i18n_1.$)("modal.object.save"), variant: "success", icon: lucide_1.Check }, "right", () => this._save());
        this._addFooterButton("cancel", { text: (0, i18n_1.$)("modal.object.cancel"), variant: "secondary" }, "right", () => this.close());
        this._addFooterButton("delete", { text: (0, i18n_1.$)("modal.object.delete"), variant: "danger", icon: lucide_1.Trash2 }, "left", () => this._deleteObject());
        // UI
        this._form = new form_1.Form(this._container);
        this._register(this._onSave);
        this._register(this.onShow((data) => {
            this._data = data;
            this._setTitle((0, i18n_1.$)("obj." + data.id));
            this._form.registerList(data.items);
        }));
        this._register(this.onClose(() => {
            this._data = null;
            this._form.unregisterList();
        }));
    }
    _save() {
        this._onSave.fire({
            obj: this._data.obj,
            items: this._form.submit()
        });
        this.close();
    }
    _deleteObject() {
        const obj = this._data.obj;
        obj.render.deleteObject(obj);
        this.close();
    }
    get onSave() {
        return this._onSave.event;
    }
}
exports.ObjectModal = ObjectModal;
